import { takeLatest, put, call } from 'redux-saga/effects';
import ApiCall from './ApiCall';
import CaseTransformer from '../../helpers/CaseTransformer';

function* ApiResponse({ payload }) {
  try {
    const body = CaseTransformer.keysToSnake(payload);
    const response = yield call(() =>
      ApiCall('/application/qualificationStep', { ...body }, true)
    );

    yield put({
      type: 'STORE_APPLICATION_UUID',
      payload: response.data.data.uuid,
    });
    yield put({
      type: 'GET_QUALIFICATIONS_DETAILS_FULFILLED',
      payload: {
        data: response.data.data,
      },
    });
    yield put({
      type: 'CHANGE_SCREEN',
      payload: {
        link: '/categories',
        form: 'cpcs-categories',
      },
    });
  } catch (e) {
    yield put({
      type: 'API_REJECTED',
      payload: e.response.data,
    });
    yield put({
      type: 'DISABLE_SPINNER',
      payload: e.response.data,
    });
    yield put({
      type: 'CANCEL_SUBMIT',
      payload: e.response.data,
    });
  }
}
function* watchLastFetchUser() {
  yield takeLatest('GET_QUALIFICATIONS_DATA', ApiResponse);
}

export default watchLastFetchUser;
